import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AppError, MessageService } from "@obg/ngx.core";
import { merge, of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { CALLING_CODE_ACTION_TYPE, CallingCodeAction } from "./calling-code.action";
import { CALLING_CODE_MESSAGE_CONTEXT } from "./calling-code.const";
import { CallingCodeService } from "./calling-code.service";

@Injectable()
export class CallingCodeEffect {
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(ContentValue.getCallingCodes)" instead
	 */
	getAll$ = createEffect(() =>
		this.actions$.pipe(
			ofType(CALLING_CODE_ACTION_TYPE.getAll),
			switchMap(() =>
				this.callingCodeService.getCallingCodes().pipe(
					map((response) => this.callingCodeAction.getAllSuccess(response)),
					catchError((error: AppError) => of(this.callingCodeAction.getAllFail(error)))
				)
			)
		)
	);

	initMessages$ = createEffect(() =>
		merge(
			this.messageService.mapErrorByContext$({
				[CALLING_CODE_ACTION_TYPE.getAllFail]: CALLING_CODE_MESSAGE_CONTEXT.getAll,
			}),
			this.messageService.mapClearByContext$({
				[CALLING_CODE_ACTION_TYPE.getAll]: CALLING_CODE_MESSAGE_CONTEXT.getAll,
			})
		)
	);

	constructor(
		private actions$: Actions,
		private callingCodeAction: CallingCodeAction,
		private callingCodeService: CallingCodeService,
		private messageService: MessageService
	) {}
}
